export const chatHistoryItems = [
  { id: "1", title: "拓扑量子材料输运特性与器件成..." },
  { id: "2", title: "EEspice A Modular Circuit Sw..." },
  { id: "3", title: "Bayesian Nonparametric Few..." },
  { id: "4", title: "多用户科研智能平台界面设计要..." },
];
